<script>
  export let src
  let player, paused
</script>

<div class="audio">
  <div class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.25 95.25"
      ><defs /><path
        fill="#40ff9b"
        d="M86.6 47.68a38.8 38.8 0 10-77.6 0 38.8 38.8 0 0077.6 0"
      /><path
        fill="none"
        stroke="#c8c8c8"
        stroke-miterlimit="10"
        stroke-width="1.41"
        d="M94.54 47.62a46.92 46.92 0 10-93.83 0 46.92 46.92 0 0093.83 0z"
      /><path
        d="M47.66 25.58A22.65 22.65 0 0025 48.23V59.7c.06 5.5 4.59 9.97 10.08 9.97h1.33c1.15 0 2.12-.97 2.12-2.12v-16c0-1.15-.97-2.11-2.12-2.11H35.1c-2.17 0-4.22.72-5.91 1.93v-3.14A18.45 18.45 0 0147.59 29.8a18.5 18.5 0 0118.48 18.42v3.14a10.06 10.06 0 00-5.92-1.93h-1.32c-1.15 0-2.12.96-2.12 2.11v16c0 1.15.97 2.12 2.12 2.12h1.32c5.56 0 10.03-4.47 10.09-9.97V48.23a22.56 22.56 0 00-22.58-22.65M24.32 55.42v6.8s-3.96-.17-4.08-1.74c-.11-1.57-.34-3.72-.34-3.72s3.44-4.13 4.42-1.34M70.93 57.25v6.81s3.96-.17 4.08-1.74c.11-1.58.34-3.73.34-3.73s-3.44-4.13-4.42-1.34"
      /></svg
    >
  </div>
  <p class="small">headphones suggested</p>
  <!-- svelte-ignore a11y-media-has-caption -->
  <audio bind:this={player} bind:paused={paused}>
    <source {src} />
  </audio>
  <div 
    class="controls"
    class:active={player && !paused && typeof(paused) != "undefined"}
  >
    <div
      class="play"
      on:click={() => player.play()}
    >
      <svg
        width="9.2152605mm"
        height="15.980833mm"
        viewBox="0 0 9.2152605 15.980833"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg"
      >
        <g>
          <g
            transform="matrix(0.35277777,0,0,-0.35277777,9.2152609,7.9904165)"
          >
            <path
              d="m 0,0 -26.122,22.65 v -45.3 z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div
      class="stop"
      on:click={() => {
        player.pause()
        player.currentTime = 0
      }}
    >
      <svg
        width="15.98mm"
        height="15.981mm"
        viewBox="0 0 15.98 15.981"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M 15.98,0 H 0 v 15.981 h 15.98 z"
            style="fill:#c8c8c8;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.352775"
          />
        </g>
      </svg>
    </div>
    <div class="pause" on:click={() => player.pause()}>
      <svg
        width="10.65389mm"
        height="15.98084mm"
        viewBox="0 0 10.65389 15.98084"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M 4.14338,15.98084 H 0 V 0 h 4.14338 z"
            style="fill:#c8c8c8;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.352778"
          />
          <path
            d="M 10.65389,15.98084 H 6.51087 V 0 h 4.14302 z"
            style="fill:#c8c8c8;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.352778"
          />
        </g>
      </svg>
    </div>
  </div>
</div>

<style lang="scss">
  .audio {
    align-items:center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    color: var(--highlightColor);
    width: 100%;
    font-family: Arvo;

    .icon {
      width: 25vmin;
      max-width: 250px;
    }

    .controls {
      margin-top: 2em;
      display: flex;
      justify-content: center;
    }
    .controls svg {
      height: 4vw;
      cursor: pointer;
      @media screen and (min-width: 800px) {
        height: 32px;
      }
    }

    .play path {
      fill:#c8c8c8;fill-opacity:1;fill-rule:nonzero;stroke:none
    }

    .active .play path {
      fill: var(--highlightColor)
    }
  }
</style>
